import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Session, STORAGEKEY } from "@/lib/curio";
import { LoginCredentials } from "@/types/auth";
import { login as loginRequest } from "@/api/session";

export const useLoginMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: LoginCredentials) => {
      const result = await loginRequest(params);
      if (result instanceof Error) {
        throw result;
      }

      if (result instanceof Session) {
        sessionStorage.setItem(STORAGEKEY, result.token.toString());
        return result;
      }

      throw new Error("Unknown response type");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["auth", "connect"] });
    }
  });
};
